module.exports = __webpack_public_path__ + "static/media/galerija_2019 (17).6e9bf1d6.jpg";